// BTD Theme — minimal interaction layer
// Cart drawer, mega-menu, login gate

(function () {
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartBackdrop = document.querySelector('[data-cart-backdrop]');
  const megaMenu = document.querySelector('[data-mega-menu]');
  const searchPopover = document.querySelector('[data-search-popover]');

  function setCartOpen(open) {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (cartBackdrop) cartBackdrop.setAttribute('data-open', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  function setMegaOpen(open) {
    if (!megaMenu) return;
    megaMenu.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  function setSearchOpen(open) {
    if (!searchPopover) return;
    searchPopover.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) {
      const input = searchPopover.querySelector('[data-search-input]');
      if (input) setTimeout(() => input.focus(), 50);
    }
  }

  function closeAll() {
    setCartOpen(false);
    setMegaOpen(false);
    setSearchOpen(false);
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-cart]'))    { e.preventDefault(); setCartOpen(true); }
    if (e.target.closest('[data-close-cart]'))   { e.preventDefault(); setCartOpen(false); }
    if (e.target.closest('[data-cart-backdrop]')) setCartOpen(false);

    if (e.target.closest('[data-open-search]'))  { e.preventDefault(); setSearchOpen(true); }
    if (e.target.closest('[data-close-search]')) { e.preventDefault(); setSearchOpen(false); }

    if (e.target.closest('[data-open-mega]'))  { e.preventDefault(); setMegaOpen(true); }
    if (e.target.closest('[data-mega-backdrop]')) setMegaOpen(false);
    if (e.target.closest('[data-close-mega]')) {
      // Only close for explicit close buttons, not navigation links that happen to carry the attr
      const el = e.target.closest('[data-close-mega]');
      if (el.tagName === 'BUTTON') { e.preventDefault(); setMegaOpen(false); }
      else { setMegaOpen(false); /* let link navigate */ }
    }

    // Login gate — redirects to Shopify customer login
    if (e.target.closest('[data-open-login]')) {
      e.preventDefault();
      window.location.href = window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root + 'account/login'
        : '/account/login';
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  // Collection filter (pill buttons) + sort
  const filterState = { family: '', series: '', form: '' };
  let sortMode = 'featured';

  function readAllItems() {
    return [
      ...document.querySelectorAll('[data-product-list] .product-list__item'),
      ...document.querySelectorAll('[data-product-list-list] .product-list-row'),
    ];
  }

  function applyFilters() {
    const items = readAllItems();
    let visible = 0;
    items.forEach((item) => {
      const match =
        (!filterState.family || item.dataset.family === filterState.family) &&
        (!filterState.series || item.dataset.series === filterState.series) &&
        (!filterState.form   || item.dataset.form   === filterState.form);
      item.style.display = match ? '' : 'none';
      if (match) visible++;
    });
    // Visible count is 2x because we render both grid and list DOM; divide by 2
    const count = document.querySelector('[data-visible-count]');
    if (count) count.textContent = Math.round(visible / 2);
  }

  function applySort() {
    ['[data-product-list]', '[data-product-list-list]'].forEach((sel) => {
      const container = document.querySelector(sel);
      if (!container) return;
      const items = Array.from(container.children).filter(
        (c) => c.dataset && (c.dataset.title || c.classList.contains('product-list__item') || c.classList.contains('product-list-row'))
      );
      items.sort((a, b) => {
        if (sortMode === 'price-asc')  return (+a.dataset.price || 0) - (+b.dataset.price || 0);
        if (sortMode === 'price-desc') return (+b.dataset.price || 0) - (+a.dataset.price || 0);
        if (sortMode === 'az') return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        return 0; // featured keeps original order (can't re-sort from DOM alone)
      });
      items.forEach((it) => container.appendChild(it));
    });
  }

  // Filter chip clicks
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('.filter-chip[data-filter]');
    if (!chip) return;
    e.preventDefault();
    const group = chip.getAttribute('data-filter');
    const value = chip.getAttribute('data-value') || '';
    filterState[group] = value;
    // De-activate siblings in same group
    document.querySelectorAll(`.filter-chip[data-filter="${group}"]`).forEach((c) => {
      const active = c === chip;
      c.classList.toggle('is-active', active);
      c.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    applyFilters();
    updateCollectionHeader();
  });

  // Update the big collection headline based on active Family / Series filters.
  // Family wins over Series; fall back to the server-rendered default otherwise.
  function updateCollectionHeader() {
    const titleEl = document.querySelector('[data-header-title]');
    if (!titleEl) return;
    const defaultTitle = titleEl.getAttribute('data-default-title') || 'Devices';

    let nextTitle = defaultTitle;
    if (filterState.family) {
      nextTitle = filterState.family;       // e.g. "HairTimecess", "HairBeauron", "Repronizer"
    } else if (filterState.series) {
      nextTitle = filterState.series + ' Series';
    }
    if (titleEl.textContent !== nextTitle) titleEl.textContent = nextTitle;
  }

  // Sort dropdown
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-sort]');
    if (!sel) return;
    sortMode = sel.value;
    applySort();
  });

  // Grid / list view toggle
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-view]');
    if (!btn) return;
    const mode = btn.getAttribute('data-view');
    const grid = document.querySelector('[data-product-list]');
    const list = document.querySelector('[data-product-list-list]');
    if (grid) grid.style.display = mode === 'grid' ? '' : 'none';
    if (list) list.style.display = mode === 'list' ? '' : 'none';
    document.querySelectorAll('[data-view]').forEach((b) => {
      const active = b === btn;
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
      b.style.background = active ? 'var(--ink)' : 'transparent';
      b.style.color = active ? 'var(--paper)' : 'var(--ink)';
    });
  });

  // Specifier quiz — score answers → series
  document.addEventListener('change', (e) => {
    const input = e.target.closest('.quiz input[type="radio"]');
    if (!input) return;
    const env  = document.querySelector('input[name="q_env"]:checked');
    const hair = document.querySelector('input[name="q_hair"]:checked');
    const bud  = document.querySelector('input[name="q_bud"]:checked');
    if (!env || !hair || !bud) return;

    const budScore  = bud.value === 'flag' ? 4 : bud.value === 'mid' ? 2 : 0;
    const envScore  = env.value === 'editorial' ? 3 : env.value === 'chair' ? 2 : 0;
    const hairScore = hair.value === 'coarse' ? 2 : hair.value === 'med' ? 1 : 0;
    const score = budScore + envScore + hairScore;

    let series, reason;
    if (score >= 7)      { series = '107D'; reason = 'Flagship tier — editorial volume + coarse hair demand the highest ceiling.'; }
    else if (score >= 5) { series = '27D';  reason = 'Professional tier — a daily-driver for full pro chairs.'; }
    else if (score >= 3) { series = '7D';   reason = 'The bestseller — the most-specified device among Bioprogramming pros.'; }
    else if (score >= 1) { series = '4D';   reason = 'Foundational tier — the right entry point for light pro use.'; }
    else                 { series = '3D';   reason = 'Core tier — the originating density.'; }

    const resultBox = document.querySelector('[data-quiz-result]');
    const seriesEl  = document.querySelector('[data-quiz-rec-series]');
    const reasonEl  = document.querySelector('[data-quiz-rec-reason]');
    const linkEl    = document.querySelector('[data-quiz-rec-link]');
    if (resultBox && seriesEl && reasonEl && linkEl) {
      seriesEl.textContent = series;
      reasonEl.textContent = reason;
      linkEl.textContent = 'Filter to ' + series + ' →';
      linkEl.href = '/collections/' + series.toLowerCase();
      resultBox.style.display = 'block';
    }
  });

  // PDP quantity stepper
  document.addEventListener('click', (e) => {
    const inc = e.target.closest('[data-qty-inc]');
    const dec = e.target.closest('[data-qty-dec]');
    if (!inc && !dec) return;
    e.preventDefault();
    const form = (inc || dec).closest('form');
    const input = form && form.querySelector('[data-qty-input]');
    if (!input) return;
    let val = parseInt(input.value, 10) || 1;
    if (inc) val += 1;
    if (dec) val = Math.max(1, val - 1);
    input.value = val;
  });

  // Cart line edit — quantity stepper + remove (cart page + drawer)
  let cartLineBusy = false;
  async function changeCartLine(key, quantity) {
    if (cartLineBusy) return;
    cartLineBusy = true;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!res.ok) throw new Error('cart change failed: ' + res.status);
      window.location.reload();
    } catch (err) {
      console.error(err);
      cartLineBusy = false;
    }
  }

  document.addEventListener('click', (e) => {
    const dec    = e.target.closest('[data-cart-line-dec]');
    const inc    = e.target.closest('[data-cart-line-inc]');
    const remove = e.target.closest('[data-cart-line-remove]');
    if (!dec && !inc && !remove) return;
    const row = e.target.closest('[data-line-key]');
    if (!row) return;
    e.preventDefault();
    const key = row.getAttribute('data-line-key');
    const input = row.querySelector('[data-cart-line-qty]');
    let qty = parseInt(input && input.value, 10);
    if (isNaN(qty)) qty = 1;
    if (inc)         qty = qty + 1;
    else if (dec)    qty = Math.max(0, qty - 1);
    else if (remove) qty = 0;
    if (input) input.value = qty;
    changeCartLine(key, qty);
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-line-qty]');
    if (!input) return;
    const row = input.closest('[data-line-key]');
    if (!row) return;
    let qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    input.value = qty;
    changeCartLine(row.getAttribute('data-line-key'), qty);
  });

  // PDP thumbnail swap
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-pdp-thumb]');
    if (!thumb) return;
    const full = thumb.getAttribute('data-full');
    const mainImg = document.querySelector('[data-main-img]');
    if (mainImg && full) mainImg.src = full;
    document.querySelectorAll('[data-pdp-thumb]').forEach((t) => {
      t.style.borderColor = t === thumb ? 'var(--ink)' : 'var(--line)';
    });
  });

  // Product tabs (Overview / Specs / Protocol)
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('.product-tabs [data-tab]');
    if (!tab) return;
    const name = tab.getAttribute('data-tab');
    const nav = tab.closest('.product-tabs');
    if (!nav) return;

    nav.querySelectorAll('[data-tab]').forEach((btn) => {
      const active = btn.getAttribute('data-tab') === name;
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
      btn.style.borderBottomColor = active ? 'var(--ink)' : 'transparent';
      btn.style.color = active ? 'var(--ink)' : 'var(--ink-mute)';
    });

    // Swap panels (scoped to the same section wrapper)
    const scope = nav.closest('section') || document;
    scope.querySelectorAll('[data-panel]').forEach((panel) => {
      panel.style.display = panel.getAttribute('data-panel') === name ? 'block' : 'none';
    });
  });
})();
